import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { useEasierTheme } from "datalign-themes";
import InfoOptionType from "models/info-option-type";
import React from "react";
import { MaterialIcon } from "ui-widgets";

const InfoOption = ({
  infoOption,
  handleInfoOption,
}: {
  infoOption: InfoOptionType;
  handleInfoOption: (
    event: React.MouseEvent<HTMLElement>,
    infoOption: InfoOptionType,
  ) => void;
}) => {
  const easierTheme = useEasierTheme();

  return (
    <ToggleButtonGroup
      aria-label="Info option group"
      sx={{ borderRadius: "2px" }}
      value={infoOption}
      onChange={handleInfoOption}
      exclusive
      size="small"
    >
      <ToggleButton
        value="summary"
        sx={{
          backgroundColor:
            infoOption === "summary"
              ? easierTheme?.Colour.PrimaryContainer()
              : undefined,
        }}
      >
        <MaterialIcon icon="expand_circle_up" />
      </ToggleButton>
      <ToggleButton
        value="detail"
        sx={{
          backgroundColor:
            infoOption === "detail"
              ? easierTheme?.Colour.PrimaryContainer()
              : undefined,
        }}
      >
        <MaterialIcon icon="expand_circle_down" />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};
export default InfoOption;
